import {bibleConstants} from './constants/bibleConstants'

const bibleSave = (biblesInput: any) => {
	return {
		type: bibleConstants.BibleSaveRequest,
		input: biblesInput
  };
};

const bibleGetDetail = (id: any) => {
	return {
		type: bibleConstants.BibleGetDetailRequest,
		input: id
  };
};

const bibleGetByFilter = (filterInput: any) => {
	return {
		type: bibleConstants.BibleGetByFilterRequest,
		input: filterInput
  };
};

const bibleDelete = (id: any) => {
	return {
		type: bibleConstants.BibleDeleteRequest,
		input: id
  };
};

const bibleGetAll = () => {
	return {
		type: bibleConstants.BibleGetAllRequest
	};
};

const bibleTranslationSearch = (input, v) => {
	return {
		type: bibleConstants.BibleTranslationSearchRequest,
		input: input,
		version:v
	}
}

export const bibleAction = {
	bibleSave,
	bibleGetDetail,
	bibleGetByFilter,
	bibleDelete,
	bibleGetAll,
	bibleTranslationSearch
}